exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.paySchedule[data-v-1492550b]{width:100%;border-collapse:collapse}.paySchedule td[data-v-1492550b]{border:1px solid #ccc;line-height:41px;text-align:center}.paySchedule tr.tb-td td[data-v-1492550b]{font-weight:700}td.textCenter[data-v-1492550b]{text-align:center}td.textRight[data-v-1492550b]{text-align:right}td input[data-v-1492550b]{width:100%;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1492550b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lending/installmentCollection/overDueInst.vue
// module id = 1595
// module chunks = 3